import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class GridDateLocaleTimeFormatter extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}
	formatDate = (date_string) => {
		return new Date(Date.parse(date_string)).toLocaleString();
	}

	render() {
		return (
			<td colSpan={this.props.colSpan} style={this.props.style}>
				{/*console.log(this.props)*/}
				{/*provideIntlService(this).formatDate(new Date(this.props.dataItem[this.props.field]), 'MM/d/y h:mm aa')*/}
				{this.formatDate(this.props.dataItem[this.props.field])}
			</td>
		);
	}
}
export default withRouter(connect(
)(GridDateLocaleTimeFormatter));